import React from "react";
import Sidenav from "../../components/Sidenav";
import BuyData from "./BuyData";

const DataLayout = () => (
  <>
    <div className="sm:flex">
      <div className="sm:w-1/5 md:block sm:mr-2">
        <Sidenav />
      </div>
      <div className="sm:w-4/5 mx-auto px-2 sm:mr-2">
        <BuyData />
      </div>
    </div>
  </>
);

export default DataLayout;
